import { projects } from "../../data/portfolio";
import styles from "./Project.module.css";

export default function Project() {
  const featured = projects.slice(0, 4);
  const more = projects.slice(4);

  return (
    <section id="projects" className={`section ${styles.projects}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">Selected work</p>
        <h2 className="sectionTitle">Products that moved metrics</h2>
        <p className="sectionLead">
          AI platforms, real-time systems, healthcare, and consumer apps — built with modern React stacks.
        </p>
      </div>

      <div className={styles.featured}>
        {featured.map((project, index) => (
          <article key={project.name} className={styles.feature} style={{ "--i": index }}>
            <div className={styles.featureTop}>
              <span className={styles.tag}>{project.tag}</span>
              <span className={styles.impact}>{project.impact}</span>
            </div>
            <h3>{project.name}</h3>
            <p className={styles.company}>{project.company}</p>
            <p className={styles.desc}>{project.description}</p>
            <ul className={styles.stack}>
              {project.stack.map((tech) => (
                <li key={tech}>{tech}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className={styles.moreHeader}>
        <h3>More shipped work</h3>
      </div>

      <div className={styles.more}>
        {more.map((project) => (
          <article key={project.name} className={styles.moreItem}>
            <div className={styles.moreTop}>
              <h4>{project.name}</h4>
              <span>{project.impact}</span>
            </div>
            <p>{project.description}</p>
            <p className={styles.moreMeta}>
              {project.company} · {project.stack.join(" · ")}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
